import { createContext, useContext } from 'react';

export interface LayoutContextValue {
  /** Whether the left sider is collapsed to the icon rail. */
  collapsed: boolean;
  setCollapsed: (v: boolean) => void;
  /**
   * Immersive (chrome-less) mode: hides the sider + top header + breadcrumb and
   * lets the routed page fill the entire viewport. Used by the Dispatcher screen.
   */
  immersive: boolean;
  setImmersive: (v: boolean) => void;
}

// Non-throwing defaults: CustomLayout can early-return a <Navigate/> (permission
// guard) before the provider mounts, so consumers must get safe no-ops.
const LayoutContext = createContext<LayoutContextValue>({
  collapsed: false,
  setCollapsed: () => {},
  immersive: false,
  setImmersive: () => {},
});

export const LayoutProvider = LayoutContext.Provider;

export const useLayout = (): LayoutContextValue => useContext(LayoutContext);
